import * as XLSX from "xlsx";

/* ======================================
   RAW MATERIAL EXPORT
====================================== */

export const RawMaterialExport = (list: any[]) => {
  const data = transformRawMaterialData(list);

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);

  // Header Row
  ws["A1"] = { t: "s", v: "Raw Material Name" };
  ws["B1"] = { t: "s", v: "Manufacturing Unit" };
  ws["C1"] = { t: "s", v: "Current Stock" };
  ws["D1"] = { t: "s", v: "Safety Stock" };
  ws["E1"] = { t: "s", v: "Reorder Stock" };

  XLSX.utils.book_append_sheet(wb, ws, "RawMaterials");
  XLSX.writeFile(wb, "RawMaterialInventory.xlsx");
};

/* ======================================
   TRANSFORM DATA
====================================== */

const transformRawMaterialData = (list: any[]) => {
  return list?.map((item) => ({
    "Raw Material Name": item.rawMaterialName,
    "POS Code": item.posCode,
    "Current Stock": item.currentStock,
    "Safety Stock": item.safetyStock,
    "Reorder Stock": item.reorderStock,
  }));
};
